<div class="row">

    <div class="products">

        <div class="category-title">
            {{ 'user_preferred_meals' | localise }}
        </div>

        <div class="col-12">
            <div class="row portfolio-grid">
                <ng-container *ngFor="let category of globalCategories; let i = index">
                    <div *ngIf="category.images.length > 0"
                         (click)="addCategoryToPreferred(category)"
                         class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 product-col">
                        <figure class="recipe-figure">
                            <div
                                    (click)="addCategoryToPreferred(category)"
                                    class="card-img-top animated fadeIn global-category-image"
                                    [lazyLoad]="constants.imagesUrl() + '/images/300x150/' + category.images[0].type + '/' + category.images[0].name + '/'">

                                <div class="recipe-check"
                                     [ngClass]="isCategoryPreferred(category) ? 'checked' : ''"
                                     (click)="addCategoryToPreferred(category)">
                                    <i class="fa fa-check"></i>
                                </div>
                            </div>

                            <figcaption>
                                <h4
                                        class="recipe-title-influencer">{{ category.title }}</h4>
                            </figcaption>
                        </figure>
                    </div>

                </ng-container>
            </div>
        </div>

        <div class="products-btn-wrapper">
            <button (click)="updateUserPreferredCategories()"
                    class="btn btn-block btn-success">
                {{ 'save' | localise }} ( {{ selectedPreferredCategories.length }} )
            </button>
        </div>
    </div>
</div>
